class BushnellContentSlider {
  /** @param {HTMLElement} section */
  constructor(section) {
    this.section    = section;
    this.viewport   = section.querySelector('.bushnell-csl__viewport');
    this.track      = section.querySelector('.bushnell-csl__track');
    this.dotsWrap   = section.querySelector('.bushnell-csl__dots');
    this.prevBtn    = section.querySelector('.bushnell-csl__arrow--prev');
    this.nextBtn    = section.querySelector('.bushnell-csl__arrow--next');
    this.autoplay   = section.dataset.autoplay === 'true';
    this.speed      = parseInt(section.dataset.autoplaySpeed, 10) || 5000;
    /** @type {ReturnType<typeof setTimeout> | null} */
    this.timer      = null;

    if (!this.viewport || !window.EmblaCarousel) return;

    this.embla = window.EmblaCarousel(this.viewport, { loop: true });

    this._buildDots();
    this._bindArrows();
    this._bindDots();
    this.embla.on('select', () => this._updateDots());

    if (this.autoplay) this._startAutoplay();

    section.addEventListener('mouseenter', () => this._stopAutoplay());
    section.addEventListener('mouseleave', () => { if (this.autoplay) this._startAutoplay(); });
  }

  _buildDots() {
    if (!this.dotsWrap || !this.embla) return;
    this.dotsWrap.innerHTML = '';
    this.embla.scrollSnapList().forEach((_, i) => {
      const btn = document.createElement('button');
      btn.className = 'bushnell-csl__dot' + (i === 0 ? ' is-active' : '');
      btn.setAttribute('aria-label', 'Go to slide ' + (i + 1));
      btn.type = 'button';
      this.dotsWrap && this.dotsWrap.appendChild(btn);
    });
  }

  _bindDots() {
    if (!this.dotsWrap || !this.embla) return;
    this.dotsWrap.querySelectorAll('.bushnell-csl__dot').forEach((btn, i) => {
      btn.addEventListener('click', () => this.embla && this.embla.scrollTo(i));
    });
  }

  _updateDots() {
    if (!this.dotsWrap || !this.embla) return;
    const idx = this.embla.selectedScrollSnap();
    this.dotsWrap.querySelectorAll('.bushnell-csl__dot').forEach((btn, i) => {
      btn.classList.toggle('is-active', i === idx);
    });
  }

  _bindArrows() {
    if (this.prevBtn && this.embla) this.prevBtn.addEventListener('click', () => { this.embla && this.embla.scrollPrev(); });
    if (this.nextBtn && this.embla) this.nextBtn.addEventListener('click', () => { this.embla && this.embla.scrollNext(); });
  }

  _startAutoplay() {
    this._stopAutoplay();
    this.timer = setTimeout(() => {
      if (this.embla) this.embla.scrollNext();
      this._startAutoplay();
    }, this.speed);
  }

  _stopAutoplay() {
    if (this.timer !== null) { clearTimeout(this.timer); this.timer = null; }
  }
}

function initContentSliders() {
  document.querySelectorAll('.bushnell-csl').forEach(el => {
    if (el instanceof HTMLElement) new BushnellContentSlider(el);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initContentSliders);
} else {
  initContentSliders();
}
